import Cookies from '../libs/tomcat-cookies.js';
import view from './reality-check-view.js';
import { sessionKey } from '../store/cookies.js';
import { postJson, putJson, fetchJson } from '../core/ajax-json.js';
import notifications from './../notifications.js';

const SECOND_IN_MS = 1000;
const MINUTE_IN_MS = 60 * SECOND_IN_MS;
const MAX_TIMEOUT = 60 * MINUTE_IN_MS;
const REALITY_CONTROL_COOKIE = 'RCCC';

let timeoutId;

function timerOff() {
	window.clearTimeout(timeoutId);
	timeoutId = null;
}

function setTimer() {
	if (isNaN(parseInt(Cookies.get(REALITY_CONTROL_COOKIE), 10))) {
		putJson('/player/limits/reality-check')
			.then(() => {
				setTimer();
			});
		return;
	}

	fetchJson('/player/limits/reality-check/duration')
		.then((responseDuration) => {
			fetchJson('/player/limits/reality-check/date')
				.then((response) => {
					const offset = response.result.date - Date.parse(new Date().toUTCString());
					const durationInMs = responseDuration.result.timerDuration * 60 * 1000;
					const endTime = (parseInt(Cookies.get(REALITY_CONTROL_COOKIE), 10) + durationInMs);
					const clientTimeMs = Date.parse(new Date().toUTCString());
					const timeoutTimeLeft = endTime - (clientTimeMs + offset);
					timerOn(timeoutTimeLeft);
				});

		});
}

function resetRealityCheckDuration() {
	putJson('/player/limits/reality-check')
		.then((response) => {
			const texts = response.result;
			notifications.showConfirmationMessage('default-success', texts.title, texts.message, texts.button);
			setTimer();
		});
}

function timerOn(timeoutParameter) {
	let timeout = timeoutParameter;
	if (timeoutId) {
		timerOff();
	}

	if (timeout < SECOND_IN_MS && sessionKey()) {
		view.show();
	} else {
		timeout = Math.min(timeout, MAX_TIMEOUT);
		timeoutId = window.setTimeout(() => {
			setTimer();
		}, timeout);
	}
}

function setRealityCheckDuration(minutes) {
	postJson('/player/limits/reality-check', { duration: parseInt(minutes, 10) })
		.then((response) => {
			const texts = response.result;
			notifications.showConfirmationMessage('default-success', texts.title, texts.message, texts.button);
			if (minutes > 0) {
				setTimer();
			}
		});
}


function disableRealityCheckDuration() {
	setRealityCheckDuration(-1);
}

function initResetRealityCheckDuration(cb) {
	putJson('/player/limits/reality-check')
		.then(() => {
			cb();
		});
}

function start() {
	fetchJson('/player/limits/reality-check/duration')
		.then((response) => {
			if (response.result.timerDuration !== null) {
				setTimeout(() => {
					setTimer();
				}, 2000);
			}
		});
}

function initRealityCheck() {
	if (sessionKey()) {
		if (Cookies.get('reality-check-login') === 'true') {
			Cookies.set('reality-check-login', false);
			initResetRealityCheckDuration(start);
		} else {
			start();
		}
	}
}

export {
	initRealityCheck,
	setRealityCheckDuration,
	disableRealityCheckDuration,
	resetRealityCheckDuration
};



// WEBPACK FOOTER //
// ./mobile-core/src/reality-check/reality-check.js